import { getValidAccessToken } from './getValidAccessToken';

const jsonFetch = async (url, { method = 'GET', headers = {}, body } = {}) => {
  const res = await fetch(url, {
    method,
    headers: {
      ...(body ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }

  if (!res.ok) {
    const err = new Error(data?.error || text || 'Request failed');
    err.status = res.status;
    err.code = data?.code;
    throw err;
  }

  return data;
};

export const deleteAccount = async ({ confirmationText }) => {
  const accessToken = await getValidAccessToken();
  if (!accessToken) {
    const err = new Error('Not authenticated');
    err.code = 'UNAUTHORIZED';
    throw err;
  }

  return await jsonFetch('/api/deleteAccount', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: { confirmationText },
  });
};
